import * as React from "react";
export function QuestPlayImageMobile(_a) {
    var src = _a.src, allImagesUrls = _a.allImagesUrls;
    if (src && allImagesUrls.indexOf(src) < 0) {
        console.warn("Image " + src + " is not found in allImagesUrls", allImagesUrls);
    }
    return (React.createElement(React.Fragment, null, allImagesUrls.map(function (imageUrl) {
        if (!imageUrl) {
            return null;
        }
        return (React.createElement("img", { key: imageUrl, src: imageUrl, style: {
                width: "100%",
                // This is needed to force the image to be over frame background
                position: "relative",
                display: imageUrl === src ? undefined : "none",
            } }));
    })));
}
export function QuestPlayImageDesktop(_a) {
    var src = _a.src, allImagesUrls = _a.allImagesUrls;
    return (React.createElement("div", { style: {
            position: "relative",
            height: "100%",
            width: "100%",
            overflow: "hidden",
        } }, allImagesUrls.map(function (imageUrl) {
        if (!imageUrl) {
            return null;
        }
        return (React.createElement("div", { key: imageUrl, style: {
                width: "100%",
                position: "absolute",
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                opacity: imageUrl === src ? 1 : 0,
                transition: "opacity 0.5s linear",
                backgroundImage: "url(\"" + imageUrl + "\"",
                backgroundSize: "cover",
                backgroundPosition: "center center",
            } }));
    })));
}
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicXVlc3RQbGF5LmltYWdlLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsicXVlc3RQbGF5LmltYWdlLnRzeCJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxPQUFPLEtBQUssS0FBSyxNQUFNLE9BQU8sQ0FBQztBQUUvQixNQUFNLFVBQVUsb0JBQW9CLENBQUMsRUFNcEM7UUFMQyxHQUFHLFNBQUEsRUFDSCxhQUFhLG1CQUFBO0lBS2IsSUFBSSxHQUFHLElBQUksYUFBYSxDQUFDLE9BQU8sQ0FBQyxHQUFHLENBQUMsR0FBRyxDQUFDLEVBQUU7UUFDekMsT0FBTyxDQUFDLElBQUksQ0FBQyxXQUFTLEdBQUcsbUNBQWdDLEVBQUUsYUFBYSxDQUFDLENBQUM7S0FDM0U7SUFFRCxPQUFPLENBQ0wsMENBQ0csYUFBYSxDQUFDLEdBQUcsQ0FBQyxVQUFDLFFBQVE7UUFDMUIsSUFBSSxDQUFDLFFBQVEsRUFBRTtZQUNiLE9BQU8sSUFBSSxDQUFDO1NBQ2I7UUFDRCxPQUFPLENBQ0wsNkJBQ0UsR0FBRyxFQUFFLFFBQVEsRUFDYixHQUFHLEVBQUUsUUFBUSxFQUNiLEtBQUssRUFBRTtnQkFDTCxLQUFLLEVBQUUsTUFBTTtnQkFDYixnRUFBZ0U7Z0JBQ2hFLFFBQVEsRUFBRSxVQUFVO2dCQUNwQixPQUFPLEVBQUUsUUFBUSxLQUFLLEdBQUcsQ0FBQyxDQUFDLENBQUMsU0FBUyxDQUFDLENBQUMsQ0FBQyxNQUFNO2FBQy9DLEdBQ0QsQ0FDSCxDQUFDO0lBQ0osQ0FBQyxDQUFDLENBQ0QsQ0FDSixDQUFDO0FBQ0osQ0FBQztBQUVELE1BQU0sVUFBVSxxQkFBcUIsQ0FBQyxFQU1yQztRQUxDLEdBQUcsU0FBQSxFQUNILGFBQWEsbUJBQUE7SUFLYixPQUFPLENBQ0wsNkJBQ0UsS0FBSyxFQUFFO1lBQ0wsUUFBUSxFQUFFLFVBQVU7WUFDcEIsTUFBTSxFQUFFLE1BQU07WUFDZCxLQUFLLEVBQUUsTUFBTTtZQUNiLFFBQVEsRUFBRSxRQUFRO1NBQ25CLElBRUEsYUFBYSxDQUFDLEdBQUcsQ0FBQyxVQUFDLFFBQVE7UUFDMUIsSUFBSSxDQUFDLFFBQVEsRUFBRTtZQUNiLE9BQU8sSUFBSSxDQUFDO1NBQ2I7UUFDRCxPQUFPLENBQ0wsNkJBQ0UsR0FBRyxFQUFFLFFBQVEsRUFDYixLQUFLLEVBQUU7Z0JBQ0wsS0FBSyxFQUFFLE1BQU07Z0JBQ2IsUUFBUSxFQUFFLFVBQVU7Z0JBQ3BCLElBQUksRUFBRSxDQUFDO2dCQUNQLEtBQUssRUFBRSxDQUFDO2dCQUNSLEdBQUcsRUFBRSxDQUFDO2dCQUNOLE1BQU0sRUFBRSxDQUFDO2dCQUNULE9BQU8sRUFBRSxRQUFRLEtBQUssR0FBRyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUMsQ0FBQyxDQUFDLENBQUM7Z0JBQ2pDLFVBQVUsRUFBRSxxQkFBcUI7Z0JBQ2pDLGVBQWUsRUFBRSxXQUFRLFFBQVEsT0FBRztnQkFDcEMsY0FBYyxFQUFFLE9BQU87Z0JBQ3ZCLGtCQUFrQixFQUFFLGVBQWU7YUFDcEMsR0FDRCxDQUNILENBQUM7SUFDSixDQUFDLENBQUMsQ0FDRSxDQUNQLENBQUM7QUFDSixDQUFDIn0=